// Salaries are stored annual. The period switch only changes how the number
// is entered and shown: in monthly mode the field shows annual / 12 and
// stores what was typed × 12.
import { cn } from 'cn';

export type SalaryPeriod = 'year' | 'month';

const PERIODS: { value: SalaryPeriod; label: string }[] = [
  { value: 'year', label: 'Annual' },
  { value: 'month', label: 'Monthly' },
];

/** Stored annual amount → the number to show for `period`. */
export function salaryForPeriod(annual: number | null | undefined, period: SalaryPeriod) {
  if (annual == null) return null;
  return period === 'month' ? Math.round(annual / 12) : annual;
}

/** Entered amount for `period` → the annual amount to store. */
export function salaryToAnnual(amount: number | null, period: SalaryPeriod) {
  if (amount == null) return null;
  return period === 'month' ? Math.round(amount * 12) : amount;
}

export function SalaryPeriodToggle({
  value,
  onChange,
  className,
}: {
  value: SalaryPeriod;
  onChange: (period: SalaryPeriod) => void;
  className?: string;
}) {
  return (
    <div
      role="group"
      aria-label="Salary period"
      className={cn(
        'inline-flex w-fit self-start rounded-md border border-border bg-muted p-0.5',
        className,
      )}
    >
      {PERIODS.map((p) => (
        <button
          key={p.value}
          type="button"
          aria-pressed={value === p.value}
          onClick={() => onChange(p.value)}
          className={cn(
            'rounded-sm px-2.5 py-1 text-xs font-medium outline-none focus-visible:ring-2 focus-visible:ring-ring',
            value === p.value
              ? 'bg-background text-foreground shadow-xs'
              : 'text-muted-foreground hover:text-foreground',
          )}
        >
          {p.label}
        </button>
      ))}
    </div>
  );
}
